export default __webpack_public_path__ + "static/media/5790-removebg.c80616e9.png";